<script setup>
const props = defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(["edit", "delete"]);

const columns = [
  { sorter: false },
  {
    title: "Category Name",
    dataIndex: "name",
    key: "name",
    sorter: {
      compare: (a, b) => {
        const an = (a.name || "").toLowerCase();
        const bn = (b.name || "").toLowerCase();
        return an > bn ? -1 : bn > an ? 1 : 0;
      },
    },
  },
  {
    title: "Sub Category Name",
    dataIndex: "sub_category_name",
    key: "sub_category_name",
    sorter: {
      compare: (a, b) => {
        const an = (a.sub_category_name || "").toLowerCase();
        const bn = (b.sub_category_name || "").toLowerCase();
        return an > bn ? -1 : bn > an ? 1 : 0;
      },
    },
  },
  {
    title: "",
    key: "action",
    sorter: false,
  },
];

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};
</script>

<template>
  <a-table
    class="table datatable thead-light"
    :columns="columns"
    :data-source="rows"
    :loading="loading"
    :row-selection="rowSelection"
    row-key="id"
  >
    <template #bodyCell="{ column, record }">
      <!-- Category Name -->
      <template v-if="column.key === 'name'">
        <h6 class="fw-medium mb-0">{{ record.name }}</h6>
      </template>

      <!-- Sub Category -->
      <template v-else-if="column.key === 'sub_category_name'">
        <span>{{ record.sub_category_name }}</span>
      </template>

      <!-- Actions -->
      <template v-else-if="column.key === 'action'">
        <div class="action-icon d-inline-flex">
          <a
            href="javascript:void(0);"
            class="me-2"
            @click.prevent="emit('edit', record)"
            v-can="'AccountCategory.Edit'"
          >
            <i class="ti ti-edit"></i>
          </a>
          <a
            href="javascript:void(0);"
            @click.prevent="emit('delete', record)"
            v-can="'AccountCategory.Delete'"
          >
            <i class="ti ti-trash"></i>
          </a>
        </div>
      </template>
    </template>
  </a-table>
</template>
